<template>
  <div class="weChatIM__panel clearfix">
    <div class="we__chatIM-wrapper flexbox flex__direction-column">
      <header-bar :class="{'topfixed': isTopFixed}"></header-bar>
      <div class="wcim__container flex1">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
      <tab-bar></tab-bar>
    </div>
  </div>
</template>

<script>
import headerBar from "./components/header";
import tabBar from "./components/footer";
import { mapState, mapActions ,mapGetters } from 'vuex'
import LocalStore from './fscommon/utils/localstore';
export default {
  name: "app",
  created(){
    console.log("app created")
  },
  mounted(){
    console.log("app mounted")
    if(LocalStore.isLogin()){
      this.$store.dispatch("initData");
    }
  },
  computed: {
    ...mapState([
        ]),
  },
  data() {
    return { isTopFixed: true };
  },
  components: { headerBar, tabBar }
};
</script>

<style>
@import "./assets/fonts/iconfont.css";
@import "./assets/css/reset.css";
@import "./assets/css/layout.css";
</style>



// WEBPACK FOOTER //
// src/App.vue